<style lang="scss">
#files {
    position: relative;
    z-index: 0;
    color: transparent;
}

#files:focus {
    outline: 0;
    border: 0;
    box-shadow: none;
}

.swal2-html-container {
    word-break: normal !important;
}

</style>
<template>
    <Head title="QM - Artigos"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-4xl text-white leading-tight lobster">
                Artigos
            </h2>
        </template>

        <div class="py-2 flex flex-wrap justify-center">
            <div class="w-11/12 sm:px-6 lg:px-8">
                <div class="bg-slate-100 overflow-hidden shadow-sm rounded-lg">
                    <div class="bg-slate-100 border-b border-gray-200">
                        <div class="w-full border-b p-5" v-if="modal">
                            <form @submit.prevent="formEditArticle.post('/articles/edit', options)">
                                <h2 class="lobster text-xl">Editar artigo {{ formEditArticle.article.code }}</h2>
                                <div class="my-2">
                                    <div class="flex">
                                        <div>
                                            <label for="editPrice">Preço Un.</label>
                                            <input autocomplete="off" type="text"
                                                   v-model="formEditArticle.article.price" required
                                                   class="h-7 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded p-0 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 w-16">
                                        </div>
                                        <div class="flex pl-5">
                                            <div>Descrição&nbsp;</div>
                                            <textarea name="observations" v-model="formEditArticle.article.description"
                                                      id="observations" rows="1" style="min-width:300px;"
                                                      class="appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"></textarea>
                                        </div>
                                    </div>
                                    <div class="inline bg-slate-100 relative py-1 mr-5" style="z-index: 2;">
                                        <label for="files_edit"
                                               class="inline bg-white cursor-pointer hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow px-5"><i
                                            class="fas fa-upload"></i> Adicionar imagens</label>
                                    </div>
                                    <div class="inline">
                                        <input :style="{marginLeft: fileMarginLeft}" id="files_edit" type="file"
                                               multiple
                                               accept="image/png, image/gif, image/jpeg"
                                               class="lg:inline"
                                               @input="formEditArticle.newImages = $event.target.files">
                                    </div>
                                </div>
                                <div class="relative inline-block cursor-pointer"
                                     v-for="(image, i) in formEditArticle.oldImages">
                                    <input type="image"
                                           class="inline-block rounded-lg mr-1 cursor-pointer"
                                           :src="'/storage/img/articles/' + formEditArticle.article.id + '/' + image.filename.split('.').slice(0, -1).join('.') + '-thumbnail.' + image.filename.split('.').pop() "
                                           :width="50">
                                    <div class="edit-image flex items-center justify-center" @click="removeImage(i)">x
                                    </div>
                                </div>
                                <div>
                                    <button
                                        class="bg-white hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow px-5"
                                        type="submit"><i class="fa fa-save"></i> <span>Guardar</span></button>
                                    <button @click="modal = false"
                                            class="bg-white hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow px-5"
                                            type="button"><i class="fa fa-times"></i> <span>Fechar</span></button>
                                </div>
                            </form>
                        </div>
                        <div id="app">
                            <div id="loader"
                                 class="fixed w-full h-full left-0 top-0 flex justify-center content-center flex-wrap z-10 bg-slate-900/75"
                                 :class="{hidden: loaderHidden}">
                                <div class="py-5 bg-white rounded-lg text-center" style="opacity: 0.8;">
                                    <img class="inline-block" src="/storage/img/loader.gif"/>
                                </div>
                            </div>
                            <form class="flex justify-center sm:justify-between flex-wrap"
                                  @submit.prevent="form.post('/articles', options)">
                                <div class="flex justify-center sm:justify-between flex-wrap px-6 pt-6">
                                    <div class="flex items-center pr-2">
                                        Artigo nº <input autocomplete="off" type="text" v-model="form.code" required
                                                         class="h-7 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded p-0 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 w-16">
                                        <p v-if="form.errors.code" class="text-red-500 text-center text-xs italic">
                                            {{ form.errors.code }}</p>
                                    </div>
                                    <div class="flex items-center pl-2">
                                        Preço Un. <input autocomplete="off" type="number" step=".01" min=".01"
                                                         v-model="form.price" required
                                                         class="h-7 appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded p-0 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 w-16">
                                        <p v-if="form.errors.price" class="text-red-500 text-center text-xs italic">
                                            {{ form.errors.price }}</p>
                                    </div>
                                    <div class="flex items-center pl-2">
                                        <div>Descrição&nbsp;</div>
                                        <textarea name="observations" v-model="form.description" id="observations"
                                                  rows="1" style="min-width:300px;"
                                                  class="appearance-none bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"></textarea>
                                    </div>
                                    <div class="py-2 sm:py-0 flex items-center">
                                        <div class="inline bg-slate-100 relative py-1 mx-5" style="z-index: 2;">
                                            <label for="files"
                                                   class="inline bg-white cursor-pointer hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow px-5"><i
                                                class="fas fa-upload"></i> Escolher imagens</label>
                                            <p v-if="form.errors.files" class="text-red-500 text-center text-xs italic">
                                                Escolha pelo menos uma imagem</p>
                                        </div>
                                        <div class="inline">
                                            <input :style="{marginLeft: fileMarginLeft}" id="files" type="file" multiple
                                                   accept="image/png, image/gif, image/jpeg"
                                                   class="hidden lg:inline" required
                                                   @input="form.files = $event.target.files">
                                        </div>
                                    </div>
                                    <div class="pb-2 sm:pb-0 flex items-center">
                                        <button
                                            class="bg-white hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow px-5"
                                            type="submit"><i class="fa fa-save"></i> <span>Guardar</span></button>
                                    </div>
                                </div>
                                <div class="pt-6 px-6">
                                    <button
                                        @click="deleteRows"
                                        class="self-end bg-white hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow px-5"
                                        type="button"><i class="fa fa-trash"></i>
                                        <span>Eliminar artigos selecionados</span>
                                    </button>
                                </div>
                            </form>
                            <Table v-bind="compProps"
                                   @edit="edit" @checkRows="checkRows($event)" @open-unreserveds="openUnreserveds"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import {Head} from '@inertiajs/inertia-vue3';
import Table from '@/Components/Order/Table.vue';
import Validations from '@/Components/Order/Validations.vue';
import {useForm} from '@inertiajs/inertia-vue3';
import Swal from "sweetalert2";
import {Inertia} from "@inertiajs/inertia";
import {computed, onMounted, reactive, ref, watch} from "vue";

export default {
    components: {
        BreezeAuthenticatedLayout,
        Head,
        Table,
        Validations
    },
    props: ['articles', 'site_url', 'total', 'filters'],
    setup(props) {
        const page = ref(props.filters.offset === 0 ? 1 : props.filters.offset / props.filters.limit + 1);
        const myKey = ref(0);
        const loaderHidden = ref(true);
        let checkedRows = [];

        // props.articles = props.articles.map((el) => {
        //     el.unreserveds = 0;
        //     el.order_line.forEach((line) => {
        //         if (line.reserved < 1)
        //             el.unreserveds += parseInt(line.qtd, 10);
        //     });
        //     return el;
        // });

        const isReSearch = ref(true);
        onMounted(() => isReSearch.value = false)

        function checkRows(event) {
            checkedRows = event;
        }

        function deleteRows() {
            if (checkedRows.length > 0) {
                Swal.fire({
                    title: '<strong class="lobster">Tens a certeza?</strong>',
                    icon: 'question',
                    html:
                        'Com esta ação vai eliminar uma série de artigos',
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText:
                        '<i class="fa fa-thumbs-up"></i> Força',
                    confirmButtonAriaLabel: 'Thumbs up, great!',
                    cancelButtonText:
                        '<i class="fa fa-thumbs-down"></i> Esquece',
                    cancelButtonAriaLabel: 'Thumbs down'
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        loaderHidden.value = false;
                        Inertia.patch('/articles', {
                            articles: checkedRows,
                            filters: props.filters
                        }, {
                            preserveState: true,
                            onSuccess: (result) => {
                                page.value = result.props.filters.offset === 0 ? 1 : result.props.filters.offset / result.props.filters.limit + 1;
                                loaderHidden.value = true;
                                Inertia.get('/articles');
                            },
                            onError: () => {
                                Swal.fire('Erro, por favor tente mais tarde!', '', 'error')
                            }
                        })
                    } else if (result.isDenied) {
                        Swal.fire('Changes are not saved', '', 'info')
                    }
                })
            } else {
                Swal.fire(
                    'Nada a fazer',
                    'Não tem nada selecionado',
                    'info'
                )
            }
        }
        const formEditArticle = useForm({
            article: {
                price: null,
                description: null
            },
            oldImages: null,
            newImages: null
        });

        const form = useForm({
            code: null,
            files: null,
            price: null,
            description: null,
            filters: Object.fromEntries(new URLSearchParams(window.location.search))
        });

        const options = {
            onBefore: function (data) {
                loaderHidden.value = false;
            },
            onSuccess: function (result) {
                loaderHidden.value = true;
                Inertia.get('/articles');
                form.reset();
                formEditArticle.reset();
            },
            onError: function (result) {
                Swal.fire('Erro!', result[0], 'error');
                loaderHidden.value = true;
            }
        }

        const openUnreserveds = (data) => {
            const article = data.data.value;
            const openOrders = article.order_line.filter((el) => el.reserved < 1 && el.order !== null);
            let totals = {};

            let html = 'Para este artigo (' + article.code + ') existem as seguintes quantidades em falta<br/><table class="shadow-none mx-auto w-3/4 mt-5">' +
                '<thead class="shadow-none bg-gray-50">' +
                '<tr>' +
                '<th class="text-left px-4 sm:px-8">Enc.</th>' +
                '<th class="text-left px-4 sm:px-8">Qtd.</th>' +
                '<th class="text-left px-4 sm:px-8">Tam.</th>' +
                '<th class="text-center px-4 sm:px-10">Cor</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>';

            openOrders.forEach(el => {
                if (totals[el.tamanho] === undefined)
                    totals[el.tamanho] = {};

                if (totals[el.tamanho][el.cor] === undefined) {
                    totals[el.tamanho][el.cor] = parseInt(el.qtd, 10);
                } else {
                    totals[el.tamanho][el.cor] += parseInt(el.qtd, 10);
                }

                html += '\
            <tr>\
                <td class="text-sm text-blue-500"><a href="/orders/list/1%2C2%2C3%2C4%2C5?search=' + el.order_id + '" target="_blank">' + el.order_id + '</a></td>\
                <td class="text-sm text-gray-500 text-center">' + el.qtd + '</td>\
                <td class="text-sm text-gray-500 text-center">' + el.tamanho + '</td>\
                <td class="text-sm text-gray-500 text-center">' + el.cor + '</td>\
            </tr>\
            '
            });

            html += '</tbody></table>';

            if (Object.keys(totals).length > 0) {
                html += '<p class="font-bold mt-5 mb-2 lobster">Totais</p><table class="shadow-none mx-auto w-3/4">\
                                <thead class="shadow-none bg-gray-50">\
                                <tr>\
                                <th class="text-left px-4 sm:px-8">Qtd.</th>\
                                <th class="text-center px-4 sm:px-8">Tam.</th>\
                                <th class="text-left px-4 sm:px-10">Cor</th>\
                                </tr>\
                                </thead>';
            }

            Object.keys(totals).forEach((el) => {
                Object.keys(totals[el]).forEach((el2) => {
                    html += '\
            <tr>\
                <td class="text-sm text-gray-500">' + totals[el][el2] + '</td>\
                <td class="text-sm text-gray-500">' + el + '</td>\
                <td class="text-sm text-gray-500 text-center">' + el2 + '</td>\
            </tr>\
            '
                });
            });

            Swal.fire({
                title: '<strong class="lobster">Quantidades em falta</strong>',
                icon: 'warning',
                html: html,
                showCloseButton: true,
                focusConfirm: false,
                confirmButtonText:
                    'OK',
                confirmButtonAriaLabel: 'OK',
                customClass: 'swal-wide',
            });
        }
        const modal = ref(false)
        const edit = (row) => {
            let editRow = JSON.parse(JSON.stringify(row));
            formEditArticle.oldImages = ref(editRow.images);
            formEditArticle.article = editRow;
            modal.value = true;
        }

        const removeImage = (i) => {
            formEditArticle.oldImages.splice(i, 1);
        }

        const onlyPaidArticles = ref(props.filters.onlyPaidArticles);
        const compProps = computed(() => {
            return {
                key: myKey,
                has_checkbox: true,
                columns: columns,
                page: page,
                statuses: [],
                isReSearch: isReSearch,
                rows: props.articles,
                total: props.total,
                articlesTable: true,
                site_url: props.site_url,
                onlyPaidArticles: onlyPaidArticles,
            };
        });
        watch(() => onlyPaidArticles.value,
            () => {
                loaderHidden.value = false;
                Inertia.get(window.location.pathname, {
                    offset: props.filters.offset,
                    limit: props.filters.limit,
                    order: props.filters.order,
                    sort: props.filters.sort,
                    search: props.filters.search && props.filters.search.length > 0 ? props.filters.search : null,
                    onlyPaidArticles: onlyPaidArticles.value
                }, {
                    preserveState: false,
                    preserveScroll: true,
                    onBefore: function () {
                    },
                    onSuccess: function (aa) {
                        loaderHidden.value = true;
                    }
                })
            });
        const columns = [
            {
                label: "",
                field: "id",
                isKey: true,
                display: function () {
                    return null;
                }
            },
            {
                label: "Nr",
                field: "code",
                width: "10%",
                sortable: true
            },
            {
                label: "Descrição",
                field: "description",
                width: "25%",
                sortable: true
            }, {
                label: "Imagens",
                field: "images",
                width: "50%",
                sortable: false
            },
            {
                label: "Preço Unitário (€)",
                field: "price",
                width: "10%",
                sortable: true
            },
            {
                label: "Em falta",
                field: "order_line_sum_qtd",
                width: "5%",
                sortable: true
            }
        ];

        return {
            options,
            loaderHidden,
            form,
            formEditArticle,
            checkedRows,
            checkRows,
            deleteRows,
            myKey,
            isReSearch,
            page,
            openUnreserveds,
            edit,
            modal,
            removeImage,
            onlyPaidArticles,
            compProps,
            columns
        }
    },
    computed: {
        fileMarginLeft() {
            if (/Edg/.test(navigator.userAgent)) {
                return '-123px';
            } else if (/Chrome/.test(navigator.userAgent)) {
                return '-149px';
            } else if (/Firefox/.test(navigator.userAgent)) {
                return '-101px';
            }
        }
    }
}
</script>
<style>
.edit-image {
    opacity: 0;
    content: 'X';
    position: absolute;
    border-radius: 0.5rem;
    top: 0;
    left: 0;
    width: 50px;
    height: 92%;
    align-items: center;
    justify-content: center;
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
}

.edit-image:hover {
    opacity: 1;
}
</style>
